import { createContext, useCallback, useState } from "react"

import { Modal } from "antd"
import { isObject } from "lodash"
import { useSelector } from "react-redux"

import useInstitutionConstraint from "../../../utils/api/hooks/useInstitutionConstraint"
import InstitutionConstraintForm from "./InstitutionConstraintForm"
import { selectTranslate } from "../../../reducers/LocaleReducer/LocalReducer"

export const InstitutionConstraintModalContext = createContext()

const DEFAULT_FORM_HANDLER = { data: null, callback: null }

const InstitutionConstraintModalProvider = ({ children, toFilter = [] }) => {
  const t = useSelector(selectTranslate)

  const [formHandler, setFormHandler] = useState(DEFAULT_FORM_HANDLER)
  const [isLoading, setIsLoading] = useState(false)

  const constraintHandler = useInstitutionConstraint({ callback: formHandler.callback })

  const handleSubmit = useCallback(institutionConstraint => {
    setIsLoading(true)
    constraintHandler.upsert(institutionConstraint, formHandler.data).finally(handleCloseModal)
  }, [constraintHandler.upsert])

  const handleCloseModal = useCallback(() => setFormHandler(DEFAULT_FORM_HANDLER), [])

  return (
    <>
      <InstitutionConstraintModalContext.Provider value={{ setFormHandler }}>
        {children}
      </InstitutionConstraintModalContext.Provider>
      <Modal
        className='form-modal-without-footer'
        title={t(`institution_constraint_modal.title.create`)}
        visible={isObject(formHandler.data)}
        destroyOnClose
        footer={null}
        onCancel={handleCloseModal}
        afterClose={() => setIsLoading(false)}
      >
        {isObject(formHandler.data) && (
          <InstitutionConstraintForm
            data={formHandler.data}
            disabled={isLoading}
            toFilter={toFilter}
            onSubmit={handleSubmit}
            onCancel={handleCloseModal}
          />
        )}
      </Modal>
    </>
  )
}

export default InstitutionConstraintModalProvider